export const educationData = [
    {
        id: 1,
        institution: 'University of Mumbai',
        course: 'BSC IT In Information Technologies',
        startYear: '06/2021',
        endYear: '07/2023'
    },
    {
        id: 2,
        institution: 'Vidyalankar Polytechnic',
        course: 'Diploma of Information Technology',
        startYear: '07/2014',
        endYear: '01/2017'
    },
    {
        id: 3,
        institution: 'Hazarimal somani college of science',
        course: 'HSC',
        startYear: '06/2012',
        endYear: '02/2014'
    },
]